import {
  decidePedApplicabilityStatusFromAnswers,
  pedScopeAndExclusionsPassed,
  PED_ANSWER_KEYS,
  PED_CLASSIFICATION_VALUES,
  PED_EQUIPMENT_KIND_VALUES,
  parsePedClassification,
  parsePedEquipmentKind,
  type PedClassification,
  type PedEquipmentKind,
} from '@artem-lex/common-server/productApplicability/pedApplicability'
import type { ProductLawApplicabilityStatus } from '@/shared/hooks/api/product'
import type { LawQuestionnaireAnswerDraft } from './lawApplicabilityQuestionnaire'

export type PedApplicabilityFields = {
  equipmentKind: PedEquipmentKind | null
  classification: PedClassification | null
}

export function readPedFieldsFromAnswers(
  answers: Record<string, unknown> | null | undefined
): PedApplicabilityFields {
  if (answers == null) {
    return { equipmentKind: null, classification: null }
  }
  return {
    equipmentKind: parsePedEquipmentKind(answers),
    classification: parsePedClassification(answers),
  }
}

export function mergePedQuestionnaireAnswers(
  booleanDraft: LawQuestionnaireAnswerDraft,
  pedFields: PedApplicabilityFields
): Record<string, unknown> {
  const merged: Record<string, unknown> = { ...booleanDraft }
  if (pedFields.equipmentKind != null) {
    merged[PED_ANSWER_KEYS.equipmentKind] = pedFields.equipmentKind
  } else {
    delete merged[PED_ANSWER_KEYS.equipmentKind]
  }
  if (pedFields.classification != null) {
    merged[PED_ANSWER_KEYS.classification] = pedFields.classification
  } else {
    delete merged[PED_ANSWER_KEYS.classification]
  }
  return merged
}

export function getLivePedQuestionnaireStatus(
  booleanDraft: LawQuestionnaireAnswerDraft,
  pedFields: PedApplicabilityFields
): ProductLawApplicabilityStatus {
  return decidePedApplicabilityStatusFromAnswers(
    mergePedQuestionnaireAnswers(booleanDraft, pedFields)
  )
}

export function pedScopeAndExclusionsComplete(
  booleanDraft: LawQuestionnaireAnswerDraft
): boolean {
  return pedScopeAndExclusionsPassed(booleanDraft)
}

export { PED_CLASSIFICATION_VALUES, PED_EQUIPMENT_KIND_VALUES }
